<template>
  <div>
    <div v-if="loading" class="text-muted text-sm py-3">Cargando boletas…</div>
    <div v-else-if="!items.length" class="text-center py-4 text-muted">
      <i class="ri-file-pdf-2-line d-block" style="font-size: 1.8rem;"></i>
      <p class="mt-2 mb-0">Este colaborador no tiene boletas disponibles.</p>
      <small>Las boletas aparecen cuando la planilla del período está PAGADA.</small>
    </div>
    <div v-else class="overflow-x-auto">
      <table class="wz-table w-full">
        <thead>
          <tr>
            <th>Período</th>
            <th>Tipo de planilla</th>
            <th class="text-right">Neto</th>
            <th>Fecha de pago</th>
            <th class="text-right">Boleta</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="p in items" :key="p.detailId">
            <td>{{ monthName(p.periodMonth) }} {{ p.periodYear }}</td>
            <td>{{ p.payrollTypeName || '—' }}</td>
            <td class="text-right">S/ {{ formatNumber(p.netSalary) }}</td>
            <td>{{ formatDate(p.paidAt) }}</td>
            <td class="text-right">
              <wz-button variant="outline" size="sm" :disabled="downloadingId === p.detailId" @click="download(p)">
                <i class="ri-download-2-line mr-1"></i>{{ downloadingId === p.detailId ? 'Generando…' : 'Descargar' }}
              </wz-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Alert } from '@wizepe/wizeui'
import PayrollEngineService from '@/core/services/PayrollEngineService'
import fileDownload from 'js-file-download'

const MONTHS = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']

export default {
  name: 'PayslipsTab',
  props: {
    employeeId: { type: [Number, String], required: true },
  },
  data() {
    return {
      items: [],
      loading: false,
      downloadingId: null,
    }
  },
  methods: {
    monthName(m) { return (m >= 1 && m <= 12) ? MONTHS[m - 1] : '' },
    formatNumber(v) {
      if (v == null) return '0.00'
      return Number(v).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatDate(value) {
      if (!value) return '—'
      const s = String(value).slice(0, 10).split('-')
      return s.length === 3 ? `${s[2]}/${s[1]}/${s[0]}` : value
    },
    async load() {
      this.loading = true
      try {
        const resp = await PayrollEngineService.employeePayslips(this.employeeId)
        this.items = resp.payload || []
      } catch (e) {
        console.error(e)
        Alert.error('Error al cargar las boletas')
      } finally {
        this.loading = false
      }
    },
    async download(p) {
      this.downloadingId = p.detailId
      try {
        const resp = await PayrollEngineService.downloadPayslip(p.detailId)
        fileDownload(resp.data || resp, `boleta_${p.periodYear}-${String(p.periodMonth).padStart(2, '0')}.pdf`)
      } catch (e) {
        console.error(e)
        Alert.error('Error al generar la boleta')
      } finally {
        this.downloadingId = null
      }
    },
  },
  created() {
    this.load()
  },
}
</script>
